import React, { useState, useEffect } from 'react';
import PagesWrapper from '@/components/ui/shared/PagesWrapper';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { BetaBadge } from '@/components/ui/BetaBadge';
import IFrame from '../IFrame';
import { userService } from '../../_services';
import { Redirect } from "react-router-dom";
import { Loader2 } from 'lucide-react';

function Payment() {
    const [userdata] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem('user'));
        } catch {
            return null;
        }
    });
    const [apiBaseURL, setApiBaseURL] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const wh_id = userdata?.wholesaler_Id;
            const wh_email = userdata?.email;
            const apidata = await userService.PaymentRails(wh_id, wh_email);
            if (apidata?.length > 0) {
                setApiBaseURL(apidata[0].widgetLink);
            }
        } catch (error) {

        } finally {
            setIsLoading(false);
        }
    };

    // Auth checks
    try {
        const usertype = userService.Get_User_Type();
        if (userService.Check_LoggedIn_Status() === 'Login') {
            return <Redirect to="/login" />;
        }
        if (usertype?.toLowerCase() === 'distributor') {
            return <Redirect to='/' />;
        }
        if (usertype?.toLowerCase() === 'admin') {
            return <Redirect to='/admin/tools' />;
        }
    } catch (error) {

    }

    return (
        <PagesWrapper>
            <div className="space-y-6">
                {/* Page Header */}
                <div className="flex items-center">
                    <h1 className="text-2xl font-semibold text-foreground">
                        Payments
                        <BetaBadge />
                    </h1>
                </div>

                {/* Payment iframe content */}
                <Card>
                    <CardContent className="p-0">
                        {isLoading ? (
                            <div className="flex items-center justify-center h-[600px]">
                                <Loader2 className="h-8 w-8 animate-spin text-primary" />
                            </div>
                        ) : apiBaseURL ? (
                            <IFrame url={apiBaseURL} height={600} />
                        ) : (
                            <div className="flex items-center justify-center h-[600px] text-muted-foreground">
                                No payment portal available
                            </div>
                        )}
                    </CardContent>
                </Card>
            </div>
        </PagesWrapper>
    );
}

export default Payment;
